export const RESERVATION_TAB_KEYS = {
    UPCOMING: "2",
    ONGOING: "3",
    PAST: "4",
    REJECTED: "5",
    CANCELLED: "6",
    ALL: "7",
};

export const DEFAULT_RESERVATION_TAB = RESERVATION_TAB_KEYS.UPCOMING;

const getReservationTabOptions = (t) => [
    { label: t("upcoming"), value: RESERVATION_TAB_KEYS.UPCOMING },
    { label: t("ongoing"), value: RESERVATION_TAB_KEYS.ONGOING },
    { label: t("past"), value: RESERVATION_TAB_KEYS.PAST },
    { label: t("rejected"), value: RESERVATION_TAB_KEYS.REJECTED },
    { label: t("cancelled"), value: RESERVATION_TAB_KEYS.CANCELLED },
    { label: t("allReservations"), value: RESERVATION_TAB_KEYS.ALL },
];

export default getReservationTabOptions;
